import { Observable } from 'rxjs';
import { StateObservable, ofType } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as merch from '@webapp/sdk/merch';
import { Actions } from '../../actions';
import {
  CreateMerchSuccess,
  CreateMerchError,
  CreateMerch,
} from '../action-creators';
import { CREATE_MERCH } from '../actions';
import AppState from '../../state';
import { hasActiveSubscription } from '../../subscription-manager/selectors';

export const createMerchEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateMerch>(CREATE_MERCH),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      if (!hasActiveSubscription(state)) {
        return [new CreateMerchError('No active subscription')];
      }
      try {
        const response = await merch.createMerch(action.merch, action.artistId);

        return new CreateMerchSuccess(response);
      } catch (err) {
        return new CreateMerchError(err.message);
      }
    })
  );
